/* eslint-disable complexity */
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {
  Backdrop,
  Button,
  DialogTitle,
  Fade,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Modal,
  Paper,
  TextField,
} from '@mui/material';
import {FormattedMessage, useIntl} from 'react-intl';
import ReusableFormikCheckbox from './ReusableFormikCheckbox.jsx';
import {getImageByAgent} from '../config/agent';
import EzFormControl from 'wobi-web-common/dist/components/EzFormControl';
import YesNoRadioGroup from 'wobi-web-common/dist/components/YesNoRadioGroup';
import {fireGtmEvent} from '../utils/marketing.utils';
import { makeStyles } from 'tss-react/mui';
import {Breakpoints} from 'wobi-web-common';
import DateRangePicker from './DateRangePicker.jsx';
import moment from 'moment';
import {getDetailForm, setDetailForm} from '../utils/persistOfferDetails';
import {PregnancyAndExtremeSportsPopup} from './modals/PregnancyAndExtremeSports';

const CompleteIcon = getImageByAgent('task-complete.svg');
const carIcon = getImageByAgent('riders/Car.png');
const winterExtremeIcon = getImageByAgent('riders/WinterSports_Icon.png');
const cellphoneIcon = getImageByAgent('riders/Cellphone_Icon.png');
const laptopIcon = getImageByAgent('riders/Laptop_Icon.png');
const iturIcon = getImageByAgent('riders/Itur_Icon.png');
const extremeSportsIcon = getImageByAgent('riders/ExtremeSports_Icon.png');
const cancellationIcon = getImageByAgent('riders/Cancellation_Icon.png');
const luggageIcon = getImageByAgent('riders/Baggage_Icon.png');
const thirdPartyIcon = getImageByAgent('riders/ThirdParty_Icon.png');

const useStyles = makeStyles()((theme) => ({
  existingCoverages: {
    maxWidth: 795,
  },
  titleExplainWhatTodoText: {
    fontSize: theme.typography.pxToRem(18),
    alignSelf: 'center',
    color: theme.palette.primary.main,
    marginBottom: '10px',
    fontWeight: 700,
  },
  title: {
    marginTop: 20,
  },

  title2: {
    marginTop: 10,
  },

  checkbox: {
    padding: 10,
  },

  icon: {
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  descriptionLabel: {
    fontWeight: 700,
    display: 'block',

    width: '87%',
  },

  description: {
    fontSize: 14,
    color: '#333',
    fontWeight: 'bold',
    display: 'inline-block',
    verticalAlign: 'middle',
    width: 'calc(100% - 45px)',

    [theme.breakpoints.down(Breakpoints.mobile)]: {
      fontSize: theme.typography.pxToRem(13),
    },
  },

  descriptionAfter: {
    flex: 1,
    marginTop: 0,
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(Breakpoints.mobile)]: {
      width: '100%',
    },
  },

  descriptionAfter2: {
    color: theme.palette.primary.main,
    width: '87%',

    [theme.breakpoints.down(Breakpoints.mobile)]: {
      fontSize: theme.typography.pxToRem(11),
      marginLeft: 0,
    },
  },

  descriptionAfter2Inputs: {
    color: theme.palette.primary.main,

    [theme.breakpoints.down(Breakpoints.mobile)]: {
      marginLeft: 0,
    },
  },

  description5After2: {
    color: theme.palette.text.primary,
  },

  inputsContainer: {
    color: theme.palette.text.primary,
    margin: '20px 45px 0 0',

    [theme.breakpoints.down(Breakpoints.mobile)]: {
      margin: 0,
    },
  },

  terms: {
    marginLeft: 10,
    fontWeight: 'normal',
    verticalAlign: 'middle',

    '& > a': {
      fontWeight: 'normal',
      lineHeight: 1.43,
      fontSize: '1rem',
    },

    [theme.breakpoints.down(Breakpoints.mobile)]: {
      fontSize: theme.typography.pxToRem(13),
    },
  },

  circle: {
    verticalAlign: 'middle',
  },

  completeIcon: {
    content: '" "',
    backgroundImage: `url('${CompleteIcon}')`,
    backgroundRepeat: 'no-repeat',
    height: 16,
    width: 17,
    marginLeft: 5,
    display: 'inline-block',
  },

  submitBtn: {
    fontSize: theme.typography.fontSize,
    width: 166,
    alignSelf: 'center',
  },

  gridSubmitBtn: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 45,
  },

  hide: {
    display: 'none',
  },

  explainWhatTodoText: {
    lineHeight: 1.5,
    marginBottom: '0.2rem',
    paddingLeft: 10,
  },

  tooltip: {
    '&.laggageTooltip': {
      padding: '15px 0 8px',
      position: 'relative',
      top: -4,
    },

    '&.youngDriverGenderTooltip': {
      padding: '15px 0 8px',
      position: 'relative',
    },

    [theme.breakpoints.up(1181)]: {
      padding: '0 0 8px',
    },

    height: 55,
    padding: '12px 0 0',
    textAlign: 'right',
  },

  laggageTooltip: {
    [theme.breakpoints.down(1343)]: {
      '&:before': {
        left: '72%',
        top: '100%',
        transform: 'rotate(180deg) translateX(50%)',
      },
      position: 'absolute',
      right: '-50%',
      textAlign: 'center',
      top: '-80%',
    },
  },
  checkboxItemWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 24,
    flexWrap: 'nowrap',
    [theme.breakpoints.down(Breakpoints.mobile)]: {
      flexWrap: 'wrap',
    },
  },
  checkboxIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginRight: '12px',
    marginTop: '4px',
    minWidth: '42px',
  },

}));

const RidersList = ({
  formikValues,
  formikSetField,
  formikErrors,
  isShowSubDes = true,
  handleUpdateRiders,
  onRidersChange,
  showTitleExplainWhatTodoText = false,
  validateForm,
  setFieldError,
  hideRiders = {
    isLiable: false,
    isCharger: false,
    isEsports: false,
    isWsports: false,
    isPccover: false,
    isMobilecover: false,
    isCancellationOfSelfParticipationOnRentedCar: false,
    isDetection: false,
    isTravelsc: false,
  },
}) => {
  const intl = useIntl();
  const {classes}= useStyles();

  const [isDetection, setIsDetection] = useState(Boolean(formikValues.isDetection));
  const [isLiable, setIsLiable] = useState(Boolean(formikValues.isLiable));
  const [isCharger, setIsCharger] = useState(Boolean(formikValues.isCharger));
  const [isEsports, setIsEsports] = useState(Boolean(formikValues.isEsports));
  const [isWsports, setIsWsports] = useState(Boolean(formikValues.isWsports));
  const [isTravelc, setIsTravelc] = React.useState(false);
  const [isTravelsc, setIsTravelsc] = React.useState(Boolean(formikValues.isTravelsc));
  const [openModal, setOpenModal] = React.useState(false);
  const [isPccover, setIsPccover] = useState(Boolean(formikValues.isPccover));
  const [isMobilecover, setIsMobilecover] = useState(
    Boolean(formikValues.isMobilecover),
  );
  const [isRidersChange, setIsRidersChangeState] = useState(false);
  const isInitialRidersEffect = React.useRef(true);
  const [
    isCancellationOfSelfParticipationOnRentedCar,
    setIsCancellationOfSelfParticipationOnRentedCar,
  ] = useState(Boolean(formikValues.isCancellationOfSelfParticipationOnRentedCar));

  const [isApprovedPregnancyAndExtremeSports, setIsApprovedPregnancyAndExtremeSports] = React.useState(false);
  const [isShowPregnancyAndExtremeSportsPopup, setIsShowPregnancyAndExtremeSportsPopup] = React.useState(false);
  const [typeOfShowPregnancyAndExtremeSportsPopup, setTypeOfShowPregnancyAndExtremeSportsPopup] = React.useState('pregnancy_and_extreme_sports_both.title');
  let isPregnancyAndExtremeSportsStatus = false;
  const isPregnancy = formikValues?.isPregnancy;
  if (isPregnancy === 'yes' && (isEsports || isWsports)) {
    isPregnancyAndExtremeSportsStatus = true;
  }

  const setIsRidersChange = (hasChanges) => {
    setIsRidersChangeState(hasChanges);
    if (hasChanges) {
      onRidersChange?.(true);
    }
  };

  useEffect(() => {
    // Trigger when any relevant state or traveler changes
    if (isInitialRidersEffect.current) {
      setIsRidersChangeState(true);
      isInitialRidersEffect.current = false;
    } else {
      setIsRidersChange(true);
    }
    const oldDataDetails = getDetailForm();
    const newDataDetails = {
      ...oldDataDetails,
      travelers: formikValues.travelers,
      isDetection,
      isLiable,
      isCharger,
      isEsports,
      isWsports,
      isTravelc,
      isTravelsc,
      isPccover,
      isMobilecover,
      isCancellationOfSelfParticipationOnRentedCar,
    };

    setDetailForm(newDataDetails);
    formikSetField('travelers', formikValues.travelers);
  }, [
    isDetection,
    isLiable,
    isCharger,
    isEsports,
    isWsports,
    isTravelsc,
    isPccover,
    isMobilecover,
    isCancellationOfSelfParticipationOnRentedCar,
    formikValues.travelers, // Include travelers to detect changes in their properties
  ]);

  useEffect(() => {
    setTimeout(() => {
      setIsRidersChange(false);
    }, 1000);
  }, []);

  const clickCancellationOfSelfParticipationOnRentedCar = (traveler, value) => {
    setIsRidersChange(true);

    //  only one traveler can have this cover
    // eslint-disable-next-line array-callback-return, no-shadow
    formikValues.travelers.some((traveler) => {
      if (traveler.cancellationOfSelfParticipationOnRentedCar) {
        traveler.cancellationOfSelfParticipationOnRentedCar = false;
      }
    });
    traveler.cancellationOfSelfParticipationOnRentedCar = value;

    formikSetField('travelers', formikValues.travelers);
  };

  const renderDescriptionAfter2 = () => {
    if (isDetection === false) {
      return (
        <Grid className={classes.descriptionAfter2}>
          <span>
            {intl.formatMessage({id: 'step1.tab4.detection_bottom1'})}
          </span>
        </Grid>
      );
    }
    return null;
  };

  const updateTravelCoverItems = (event, index, key, itemToCover) => {
    setIsRidersChange(true);

    formikValues.travelers[index][itemToCover][key] = event.target.value;
    formikSetField('travelers', formikValues.travelers);
  };

  const ModalContainer = (props) => {
    const useStyles = makeStyles()((theme) => ({
      paper: {
        maxWidth: '600px',
        display: 'flex',
        maxHeight: 'calc(100% - 64px)',
        flexDirection: 'column',
        margin: '32px',
        position: 'relative',
        overflowY: 'auto',
      },
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      modalBtn: {
        fontSize: theme.typography.pxToRem(15.75),
        height: 52,
        width: '150px',
        margin: '0 20px 40px',
        lineHeight: 1,
      },
      dialogueTitle: {
        textAlign: 'center',
        color: theme.palette.secondary.main,
      },
    }));
    const {classes} = useStyles();
    const handleClose = (doCancel) => {
      setIsRidersChange(true);

      if (doCancel && props.isforBlock4) {
        setIsTravelc(false);
        props.setFieldValue('isTravelc', false);
      } else if (doCancel && !props.isforBlock4) {
        setIsTravelsc(false);
        props.setFieldValue('isTravelsc', false);
      }
      setOpenModal(false);
    };

    return (
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={openModal}
        className={`MuiModal ${classes.modal}`}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <Paper className={classes.paper}>
            <DialogTitle className={classes.dialogueTitle}>
              {intl.formatMessage({
                id: 'step1.tab5.travelc_bottom2_notation',
              })}
            </DialogTitle>
            <div style={{padding: '0 40px 40px'}}>
              {intl.formatMessage({
                id: 'step1.tab5.travelc_bottom2_notation2',
              })}
            </div>
            <div className={classes.modal}>
              <Button
                variant="contained"
                className={classes.modalBtn}
                data-testid='add-cover-btn-modal'
                onClick={() => handleClose(false)}
              >
                <FormattedMessage id='add_cover' />
              </Button>
              <Button
                variant="contained"
                className={classes.modalBtn}
                data-testid='cancel-cover-btn-modal'
                onClick={() => handleClose(true)}
              >
                <FormattedMessage id='cancel' />
              </Button>
            </div>
          </Paper>
        </Fade>
      </Modal>
    );
  };
  const renderDescription2After2 = () => {
    if (isLiable === false) {
      return (
        <Grid className={classes.descriptionAfter2}>
          <span>
            {intl.formatMessage({id: 'step1.tab4.liability_bottom1'})}
          </span>
        </Grid>
      );
    }
    return null;
  };

  const renderDescription7After2 = (values, setFieldValue) => {
    if (isTravelsc === false) {
      return (
        <span>{intl.formatMessage({id: 'step1.tab5.travelsc_bottom1'})}</span>
      );
    } else {
      return (
        <div>
          <span className={classes.description5After2}>
            {intl.formatMessage({id: 'step1.tab5.travelc_bottom2_ask'})}
          </span>
          <br />
          <EzFormControl
            name='isOwnerHospital2'
            isInlineLabel={false}
            showError={false}
          >
            <div data-testid='short-travel-from-special-reason'>
              <YesNoRadioGroup
                value={values.isOwnerHospital2}
                onChange={(event) => {
                  setIsRidersChange(true);

                  setFieldValue('isOwnerHospital2', event.target.value);
                  if (event.target.value === 'yes') {
                    setOpenModal(true);
                  }
                }}
              />
            </div>
            <FormHelperText component='span' error>
              {formikErrors.isOwnerHospital2}
            </FormHelperText>
          </EzFormControl>
          <ModalContainer setFieldValue={setFieldValue} isforBlock4={false} />
        </div>
      );
    }
  };

  const renderDescription8After2 = (traveler, index, setFieldValue) => {
    if (isPccover === false) {
      return (
        <span>{intl.formatMessage({id: 'step1.tab5.pccover_bottom1'})}</span>
      );
    } else {
      return traveler.needPcCoverage && traveler.pc ? (
        <div data-testid={`traveler-${index + 1}-pcCover`}>
          <Grid container spacing={0} className={classes.inputsContainer}>
            <Grid size={4}>
              <label htmlFor={`pccoverManufacturer${index}`}>
                {intl.formatMessage({
                  id: 'step1.tab5.pccover_bottom2_manufacturer',
                })}
              </label>
              <EzFormControl
                name={`pccoverManufacturer${index}`}
                label=''
                isInputLabel
                showError={false}
              >
                <TextField
                  id={`pccoverManufacturer${index}`}
                  data-testid={`pccoverManufacturer${index + 1}`}
                  onChange={(event) => {
                    updateTravelCoverItems(event, index, 'manufacturer', 'pc');
                  }}
                  value={traveler.pc.manufacturer}
                  margin='normal'
                  variant='outlined'
                />
              </EzFormControl>
              <FormHelperText component='span' error>
                {formikErrors?.travelers?.[index]?.pc?.manufacturer ?
                  intl.formatMessage({
                    id: formikErrors.travelers[index].pc.manufacturer,
                  }) :
                  ''}
              </FormHelperText>
            </Grid>
            <Grid size={4}>
              <label htmlFor={`pccoverModel${index}`}>
                {intl.formatMessage({id: 'step1.tab5.pccover_bottom2_model'})}
              </label>
              <EzFormControl
                name={`pccoverModel${index}`}
                label=''
                isInputLabel
                showError={false}
              >
                <TextField
                  id={`pccoverModel${index}`}
                  data-testid={`pccoverModel${index + 1}`}
                  onChange={(event) => {
                    updateTravelCoverItems(event, index, 'model', 'pc');
                  }}
                  value={traveler.pc.model}
                  margin='normal'
                  variant='outlined'
                />
              </EzFormControl>
              <FormHelperText component='span' error>
                {formikErrors?.travelers?.[index]?.pc?.model ?
                  intl.formatMessage({
                    id: formikErrors.travelers[index].pc.model,
                  }) :
                  ''}
              </FormHelperText>
            </Grid>
            <Grid size={4}>
              <label htmlFor={`pccoverYear${index}`}>
                {intl.formatMessage({id: 'step1.tab5.pccover_bottom2_year'})}
              </label>
              <EzFormControl
                name={`pccoverYear${index}`}
                label='YYYY'
                isLabelInChild
                showError={false}
              >
                <TextField
                  id={`pccoverYear${index}`}
                  data-testid={`pccoverYear${index + 1}`}
                  onChange={(event) => {
                    updateTravelCoverItems(event, index, 'year', 'pc');
                  }}
                  value={traveler.pc.year}
                  margin='normal'
                  variant='outlined'
                />
              </EzFormControl>
              <FormHelperText component='span' error>
                {formikErrors?.travelers?.[index]?.pc?.year ?
                  intl.formatMessage({
                    id: formikErrors.travelers[index].pc.year,
                  }) :
                  ''}
              </FormHelperText>
            </Grid>
          </Grid>
        </div>
      ) : null;
    }
  };
  const clickPcCoverage = (traveler, value) => {
    traveler.needPcCoverage = value;
    if (!traveler.pc) {
      traveler.pc = {};
    }
    setIsRidersChange(true);
    if (!value) {
      traveler.pc = {};
    }
    formikSetField('travelers', formikValues.travelers);
  };

  const clickMobileCoverage = (traveler, value) => {
    traveler.needMobileCoverage = value;
    if (!traveler.mobile) {
      traveler.mobile = {};
    }
    if (!value) {
      traveler.mobile = {};
    }
    setIsRidersChange(true);

    formikSetField('travelers', formikValues.travelers);
  };

  const renderDescription9After2 = (traveler, index, setFieldValue) => {
    if (isMobilecover === false) {
      return (
        <span>
          {intl.formatMessage({id: 'step1.tab5.mobilecover_bottom1'})}
        </span>
      );
    } else {
      return traveler.needMobileCoverage && traveler.mobile ? (
        <div>
          <Grid container spacing={0} className={classes.inputsContainer}>
            <Grid size={4}>
              <label htmlFor={`mobilecoverManufacturer${index}`}>
                {intl.formatMessage({
                  id: 'step1.tab5.pccover_bottom2_manufacturer',
                })}
              </label>
              <EzFormControl
                showError={false}
                name={`mobilecoverManufacturer${index}`}
                label=''
                isInputLabel
              >
                <TextField
                  data-testid={`mobilecoverManufacturer${index + 1}`}
                  id={`mobilecoverManufacturer${index}`}
                  onChange={(event) => {
                    updateTravelCoverItems(
                      event,
                      index,
                      'manufacturer',
                      'mobile',
                    );
                  }}
                  value={traveler.mobile.manufacturer}
                  margin='normal'
                  variant='outlined'
                />
              </EzFormControl>
              <FormHelperText component='span' error>
                {formikErrors?.travelers?.[index]?.mobile?.manufacturer ?
                  intl.formatMessage({
                    id: formikErrors.travelers[index].mobile.manufacturer}) :
                  ''}
              </FormHelperText>
            </Grid>
            <Grid size={4}>
              <label htmlFor={`mobilecoverModel${index}`}>
                {intl.formatMessage({id: 'step1.tab5.pccover_bottom2_model'})}
              </label>
              <EzFormControl
                showError={false}
                name={`mobilecoverModel${index}`}
                label=''
                isInputLabel
              >
                <TextField
                  data-testid={`mobilecoverModel${index + 1}`}
                  id={`mobilecoverModel${index}`}
                  onChange={(event) => {
                    updateTravelCoverItems(event, index, 'model', 'mobile');
                  }}
                  value={traveler.mobile.model}
                  margin='normal'
                  variant='outlined'
                />
              </EzFormControl>
              <FormHelperText component='span' error>
                {formikErrors?.travelers?.[index]?.mobile?.model ?
                  intl.formatMessage({
                    id: formikErrors.travelers[index].mobile.model,
                  }) :
                  ''}
              </FormHelperText>
            </Grid>
            <Grid size={4} />
          </Grid>
        </div>
      ) : null;
    }
  };
  const calculateDaysChange = (startDate, endDate) => {
    if (!startDate.isValid() || !endDate.isValid()) {
      return 0;
    }
    return endDate.diff(startDate, 'days') + 1;
  };

  const convertToUTCDate = (momentDate) => {
    return new Date(Date.UTC(momentDate.year(), momentDate.month(), momentDate.date(), 12, 0, 0));
  };

  const updateSportDateRange = (traveler, type, isStart, utcDate, date) => {
    const rangeKey = type === 'extremeSport' ? 'dateExtremeSportRange' : 'dateWinterSportRange';
    const startKey = type === 'extremeSport' ? 'startDateExtremeSport' : 'startDateWinterSport';
    const endKey = type === 'extremeSport' ? 'endDateExtremeSport' : 'endDateWinterSport';

    if (isStart) {
      
      traveler[rangeKey][startKey] = utcDate;
      
      if (traveler[rangeKey][endKey] && date.isAfter(traveler[rangeKey][endKey])) {
        traveler[rangeKey][endKey] = null;
      }
    } else {
      
      traveler[rangeKey][endKey] = utcDate;
    }
  };

  const updateDatePicker = (type, StartOrEnd, dateinput, traveler) => {
    let date = moment(dateinput);
    if (StartOrEnd === 'start' && (
      date.isBefore(moment(formikValues.policyStartDate), 'day') ||
      date.isAfter(moment(formikValues.policyEndDate), 'day')
    )) {
      date = moment(formikValues.policyStartDate);
    } else if (StartOrEnd === 'end' && (
      date.isAfter(moment(formikValues.policyEndDate), 'day') ||
      date.isBefore(moment(formikValues.policyStartDate), 'day')
    )) {
      date = moment(formikValues.policyEndDate);
    }

    const utcDate = convertToUTCDate(date);
    const isStart = StartOrEnd === 'start';
    
    setIsRidersChange(true);
    
    if (type === 'extremeSport' || type === 'winterSport') {
      updateSportDateRange(traveler, type, isStart, utcDate, date);
    }
    
    formikSetField('travelers', formikValues.travelers);
  };

  const clickDateExtremeSport = (traveler, value) => {
    traveler.needDateExtremeSport = value;
    setIsRidersChange(true);
    setFieldError('dateExtremeSportRangeError', '');
    if (!traveler.needDateExtremeSport) {
      traveler.dateExtremeSportRange = null;
    } else {
      if (traveler.needDateExtremeSport && !traveler.dateExtremeSportRange) {
        const startDate = moment(formikValues.policyStartDate);
        const endDate = moment(formikValues.policyEndDate);
        traveler.dateExtremeSportRange = {
          startDateExtremeSport: convertToUTCDate(startDate),
          endDateExtremeSport: convertToUTCDate(endDate),
        };
      }
      if (!traveler.dateExtremeSportRange.startDateExtremeSport) {
        const startDate = moment(formikValues.policyStartDate);
        traveler.dateExtremeSportRange.startDateExtremeSport = convertToUTCDate(startDate);
      }
      if (!traveler.dateExtremeSportRange.endDateExtremeSport) {
        const endDate = moment(formikValues.policyEndDate);
        traveler.dateExtremeSportRange.endDateExtremeSport = convertToUTCDate(endDate);
      }
    }
    formikSetField('travelers', formikValues.travelers);
  };

  const clickDateWinterSport = (traveler, value) => {
    traveler.needDateWinterSport = value;
    setIsRidersChange(true);
    setFieldError('dateWinterSportRangeError', '');
    if (!traveler.needDateWinterSport) {
      traveler.dateWinterSportRange = null;
    } else {
      if (traveler.needDateWinterSport && !traveler.dateWinterSportRange) {
        const startDate = moment(formikValues.policyStartDate);
        const endDate = moment(formikValues.policyEndDate);
        traveler.dateWinterSportRange = {
          startDateWinterSport: convertToUTCDate(startDate),
          endDateWinterSport: convertToUTCDate(endDate),
        };
      }
      if (!traveler.dateWinterSportRange.startDateWinterSport) {
        const startDate = moment(formikValues.policyStartDate);
        traveler.dateWinterSportRange.startDateWinterSport = convertToUTCDate(startDate);
      }
      if (!traveler.dateWinterSportRange.endDateWinterSport) {
        const endDate = moment(formikValues.policyEndDate);
        traveler.dateWinterSportRange.endDateWinterSport = convertToUTCDate(endDate);
      }
    }
    formikSetField('travelers', formikValues.travelers);
  };

  const renderDatePickerRangeTraveler = (traveler, type) => {
    if (!traveler) {
      return null;
    }
    if (type === 'extremeSport') {
      return (
        <DateRangePicker
          isRidersListInOffersStep
          hideDatePicker={!traveler.needDateExtremeSport}
          startDateValue={traveler.dateExtremeSportRange?.startDateExtremeSport}
          endDateValue={traveler.dateExtremeSportRange?.endDateExtremeSport}
          onStartChange={(date => updateDatePicker('extremeSport', 'start', date, traveler))}
          startLabel={intl.formatMessage({id: 'step1.tab1.start_date_part'})}
          onEndChange={(date => updateDatePicker('extremeSport', 'end', date, traveler))}
          endLabel={intl.formatMessage({id: 'step1.tab1.end_date_part'})}
          minStartDate={(formikValues.policyStartDate)}
          minEndDate={traveler.dateExtremeSportRange?.startDateExtremeSport || formikValues.policyStartDate}
          maxEndDate={formikValues.policyEndDate}
          maxStartDate={(formikValues.policyEndDate)}
          startError={moment(traveler.dateExtremeSportRange?.startDateExtremeSport).isValid() ? '' : intl.formatMessage({id: 'step1.tab1.start_date_error'})}
          endError={moment(traveler.dateExtremeSportRange?.endDateExtremeSport).isValid() ? '' : intl.formatMessage({id: 'step1.tab1.end_date_error'})}
          daysDifference={traveler.dateExtremeSportRange?.startDateExtremeSport && traveler.dateExtremeSportRange?.endDateExtremeSport && <FormattedMessage id='step1.tab1.days_num_winter_extreme_sports' values={{
            number: <b>{calculateDaysChange(moment(traveler.dateExtremeSportRange?.startDateExtremeSport), moment(traveler.dateExtremeSportRange?.endDateExtremeSport))}</b>
          }} />}
        />
      );
    }

    return (
      <DateRangePicker
        isRidersListInOffersStep
        hideDatePicker={!traveler.needDateWinterSport}
        startDateValue={traveler.dateWinterSportRange?.startDateWinterSport}
        endDateValue={traveler.dateWinterSportRange?.endDateWinterSport}
        onStartChange={(date => updateDatePicker('winterSport', 'start', date, traveler))}
        startLabel={intl.formatMessage({id: 'step1.tab1.start_date_part'})}
        onEndChange={(date => updateDatePicker('winterSport', 'end', date, traveler))}
        endLabel={intl.formatMessage({id: 'step1.tab1.end_date_part'})}
        minStartDate={moment(formikValues.policyStartDate)}
        minEndDate={moment(traveler.startDateWinterSport) || moment(formikValues.policyStartDate)}
        maxEndDate={moment(formikValues.policyEndDate)}
        maxStartDate={moment(formikValues.policyEndDate)}
        startError={moment(traveler.dateWinterSportRange?.startDateWinterSport).isValid() ? '' : intl.formatMessage({id: 'step1.tab1.start_date_error'})}
        endError={moment(traveler.dateWinterSportRange?.endDateWinterSport).isValid() ? '' : intl.formatMessage({id: 'step1.tab1.end_date_error'})}
        daysDifference={traveler.dateWinterSportRange?.startDateWinterSport && traveler.dateWinterSportRange?.endDateWinterSport && <FormattedMessage id='step1.tab1.days_num_winter_extreme_sports' values={{
          number: <b>{calculateDaysChange(moment(traveler.dateWinterSportRange?.startDateWinterSport), moment(traveler.dateWinterSportRange?.endDateWinterSport))}</b>
        }} />}
      />
    );
  };

  const handleGtmEvent = () => {
    try {
      const prevFormDetails = JSON.parse(sessionStorage.getItem('prevFormDetails')) || null;
      const currentFormDetails = JSON.parse(sessionStorage.getItem('travel.details-form')).values || null;

      let prevFormDetailsObject = null;
      let currentFormDetailsObject = null;

      if (prevFormDetails) {
        prevFormDetailsObject = {
          locateAndExtract: prevFormDetails?.isDetection,
          travelThirdParty: prevFormDetails?.isLiable,
          luggage: prevFormDetails?.isCharger,
          extreme: prevFormDetails?.isEsports,
          winterExtreme: prevFormDetails?.isWsports,
          cancellation: prevFormDetails?.isTravelc,
          shortening: prevFormDetails?.isTravelsc,
          pcAndTablet: prevFormDetails?.isPccover,
          mobile: prevFormDetails?.isMobilecover,
          cancellationOfSelfParticipationOnRentedCar: prevFormDetails?.isCancellationOfSelfParticipationOnRentedCar,
        };
      }

      if (currentFormDetails) {
        currentFormDetailsObject = {
          locateAndExtract: currentFormDetails?.isDetection,
          travelThirdParty: currentFormDetails?.isLiable,
          luggage: currentFormDetails?.isCharger,
          extreme: currentFormDetails?.isEsports,
          winterExtreme: currentFormDetails?.isWsports,
          cancellation: currentFormDetails?.isTravelc,
          shortening: currentFormDetails?.isTravelsc,
          pcAndTablet: currentFormDetails?.isPccover,
          mobile: currentFormDetails?.isMobilecover,
          cancellationOfSelfParticipationOnRentedCar: currentFormDetails?.isCancellationOfSelfParticipationOnRentedCar,
        };
      }

      const eventData = {
        originalData: prevFormDetailsObject,
        updatedData: currentFormDetailsObject,
      };

      fireGtmEvent('TravelUpdateCover', eventData);
    } catch (error) {
      console.error('Error handling GTM event for TravelUpdateCover:', error);
    }
  };

  const handleIsCancelSelfParticoationOnRentalCar = (v) => {
    setIsCancellationOfSelfParticipationOnRentedCar(v);
    formikSetField('isCancellationOfSelfParticipationOnRentedCar', v);
    setIsRidersChange(true);

    // if we have only one traveler, we need to change the value of the traveler
    // and in case we have only one travler of age higher than 24 so we need to change the value this traveler
    // so we need to find this traveler and change his value
    let indexOfTraveler;

    // check if we have only one traveler of age higher than 24
    for (let i = 0; i < formikValues.travelers.length; i++) {
      if (formikValues.travelers[i].age > 24) {
        if (indexOfTraveler === undefined) {
          indexOfTraveler = i;
        } else {
          indexOfTraveler = undefined;
          break;
        }
      }
    }
    if (formikValues.travelers.length === 1) {
      clickCancellationOfSelfParticipationOnRentedCar(
        formikValues.travelers[0],
        v,
      );
    } else if (indexOfTraveler !== undefined) {
      clickCancellationOfSelfParticipationOnRentedCar(
        formikValues.travelers[indexOfTraveler],
        v,
      );
    } else if (formikValues.travelers.length > 1) {
      formikValues.travelers.forEach((traveler) => {
        traveler.cancellationOfSelfParticipationOnRentedCar = false;
      });
    }
    formikSetField('travelers', formikValues.travelers);
    formikSetField('isCancellationOfSelfParticipationOnRentedCar', v);
  };

  return (
    <FormGroup>
      {showTitleExplainWhatTodoText ? (
        <Grid className={classes.titleExplainWhatTodoText} size={12}>
          <FormattedMessage id='step1.tab4.TitleExplainWhatTodoText' />
        </Grid>
      ) : null}
      <ReusableFormikCheckbox
        name='isDetection'
        label={intl.formatMessage({id: 'step1.tab4.detection'})}
        description={
          isShowSubDes &&
					intl.formatMessage({id: 'step1.tab4.detection_fulltext'})
        }
        icon={<img src={iturIcon} alt='Detection' />}
        isChecked={isDetection}
        setIsChecked={(v) => {
          setIsDetection(v);
          formikSetField('isDetection', v);
        }}
        classes={classes}
      >
        {renderDescriptionAfter2()}
      </ReusableFormikCheckbox>
      <ReusableFormikCheckbox
        name='isLiable'
        label={intl.formatMessage({id: 'step1.tab4.liability'})}
        description={
          isShowSubDes &&
					intl.formatMessage({id: 'step1.tab4.liability_fulltext'})
        }
        icon={<img src={thirdPartyIcon} alt='Liability' />}
        isChecked={isLiable}
        setIsChecked={(v) => {
          setIsLiable(v);
          formikSetField('isLiable', v);
        }}
        classes={classes}
      >
        {renderDescription2After2()}
      </ReusableFormikCheckbox>
      <ReusableFormikCheckbox
        name='isCharger'
        label={intl.formatMessage({id: 'step1.tab5.charger'})}
        description={
          isShowSubDes &&
					intl.formatMessage({id: 'step1.tab5.charger_fulltext'})
        }
        icon={<img src={luggageIcon} alt='Luggage' />}
        isChecked={isCharger}
        setIsChecked={(v) => {
          setIsCharger(v);
          formikSetField('isCharger', v);
        }}
        classes={classes}
      />
      <ReusableFormikCheckbox
        name='isEsports'
        label={intl.formatMessage({id: 'step1.tab5.esports'})}
        description={
          isShowSubDes &&
					intl.formatMessage({id: 'step1.tab5.esports_fulltext'})
        }
        icon={<img src={extremeSportsIcon} alt='Extreme Sports' />}
        isChecked={isEsports}
        setIsChecked={(v) => {
          if (isPregnancy === 'yes') {
            if (v) {
              setIsShowPregnancyAndExtremeSportsPopup(true);
              setTypeOfShowPregnancyAndExtremeSportsPopup('pregnancy_and_extreme_sports_esports.title');
            }
          }
          if (formikValues.travelers.length === 1) {
            clickDateExtremeSport(formikValues.travelers[0], v);
          }
          if (!v && formikValues.travelers.length > 1) {
            formikValues.travelers.forEach((traveler) => {
              clickDateExtremeSport(traveler, v);
            });
          }
          setIsEsports(v);
          formikSetField('isEsports', v);
          if (!v && !isWsports) {
            setIsApprovedPregnancyAndExtremeSports(false);
          }
        }}
        classes={classes}
      >
        {formikValues.travelers.length > 1 && formikValues.isEsports && isEsports ? formikValues.travelers.map((traveler, i) => (traveler.gender === 1 ? false :
          (<div key={`traveler-${i}-extremeSport`}
            style={{width: '100%'}}
          >
            <FormControlLabel
              style={{alignItems: 'flex-start'}}
              key={`traveler-${i}-DateExtremeSport`}
              label={traveler.fullName}
              aria-label={`${traveler.fullName} ${intl.formatMessage({id: 'step1.tab5.pccover_ariaLabel'})}`}
              control={<ReusableFormikCheckbox
                name='traveler-DateExtremeSport'
                classes={classes}

                data-testid={`traveler-${i + 1}-DateExtremeSport`}
                isChecked={Boolean(traveler.needDateExtremeSport)}
                setIsChecked={( value) => {
                  formikSetField(`traveler-${i}-DateExtremeSport`, value);
                  clickDateExtremeSport(traveler, value);
                }}
              />}
            />

            <Grid item xs={12} >
              {renderDatePickerRangeTraveler(traveler,'extremeSport') }
            </Grid>
            {formikValues.travelers.length === 1 ?
              renderDatePickerRangeTraveler(formikValues.travelers[0], 'extremeSport') : null}

          
          </div>))) :

          null
        }
        {formikValues.travelers.length === 1 ? renderDatePickerRangeTraveler(formikValues.travelers[0], 'extremeSport') : null}
        <PregnancyAndExtremeSportsPopup
          typeOfShowPregnancyAndExtremeSportsPopup={typeOfShowPregnancyAndExtremeSportsPopup}
          isOpen={isShowPregnancyAndExtremeSportsPopup}
          onClose={setIsShowPregnancyAndExtremeSportsPopup}
          onCheckBoxEvent={setIsApprovedPregnancyAndExtremeSports}
          sportsStatus = {{isEsports,
            isWsports}}
        />

        <Grid item xs={12} className={classes.descriptionAfter2Inputs}>
          {formikValues.travelers.length > 1 ?
            <FormHelperText component='span' error>
              {formikErrors.dateExtremeSportRangeError}
            </FormHelperText> :
            null}

        </Grid>
      </ReusableFormikCheckbox>
      <ReusableFormikCheckbox
        name='isWsports'
        label={intl.formatMessage({id: 'step1.tab5.wsports'})}
        description={
          isShowSubDes &&
					intl.formatMessage({id: 'step1.tab5.wsports_fulltext'})
        }
        icon={<img src={winterExtremeIcon} alt='Winter Sports' />}
        isChecked={isWsports}
        setIsChecked={(v) => {
          if (isPregnancy === 'yes') {
            if (v) {
              setTypeOfShowPregnancyAndExtremeSportsPopup('pregnancy_and_extreme_sports_wsports.title');
              setIsShowPregnancyAndExtremeSportsPopup(true);
            }
          }
          if (formikValues.travelers.length === 1) {
            clickDateWinterSport(formikValues.travelers[0], v);
          } else if (!v && formikValues.travelers.length > 1) {
            formikValues.travelers.forEach((traveler) => {
              clickDateWinterSport(traveler, v);
            });
          }
          setIsWsports(v);
          if (!isEsports && !v) {
            setIsApprovedPregnancyAndExtremeSports(false);
          }
          formikSetField('isWsports', v);
        }}
        classes={classes}
      >
        {formikValues.travelers.length > 1 && formikValues.isWsports && isWsports ? formikValues.travelers.map((traveler, i) => (traveler.gender === 1 ? false :
          (<div style={{width: '100%'}}>
            <FormControlLabel
              style={{alignItems: 'flex-start'}}

              key={`traveler-${i}-DateWinterSport`}
              label={traveler.fullName}
              aria-label={`${traveler.fullName} ${intl.formatMessage({id: 'step1.tab5.pccover_ariaLabel'})}`}
              control={<ReusableFormikCheckbox
                name='traveler-DateWinterSport'
                classes={classes}

                data-testid={`traveler-${i + 1}-DateWinterSport`}
                isChecked={Boolean(traveler.needDateWinterSport)}
                setIsChecked={(value) => {
                  formikSetField(`traveler-${i}-DateWinterSport`, value);
                  clickDateWinterSport(traveler, value);
                }}
              />}
            />

            <Grid item xs={12} className={classes.descriptionAfter2Inputs}>
              {renderDatePickerRangeTraveler(traveler) }
            </Grid>
          </div>))) :

          null
        }
        {formikValues.travelers.length === 1 ? renderDatePickerRangeTraveler(formikValues.travelers[0]) : null}
        <Grid item xs={12} className={classes.descriptionAfter2Inputs}>
          {formikValues.travelers.length > 1 ? <FormHelperText component='span' error>{formikErrors.dateWinterSportError}</FormHelperText> : null }

        </Grid>
      </ReusableFormikCheckbox>
      <ReusableFormikCheckbox
        name='isTravelsc'
        label={intl.formatMessage({id: 'step1.tab5.travelsc'})}
        description={
          isShowSubDes &&
					intl.formatMessage({id: 'step1.tab5.travelsc_fulltext'})
        }
        icon={<img src={cancellationIcon} alt='Cancellation' />}
        isChecked={isTravelsc}
        setIsChecked={(v) => {
          setIsTravelsc(v);
          formikSetField('isTravelsc', v);
        }}
        classes={classes}
      >
        <Grid className={`${classes.descriptionAfter}`} size={12}>
          {renderDescription7After2(formikValues, formikSetField)}
        </Grid>
      </ReusableFormikCheckbox>
      <ReusableFormikCheckbox
        name='isPccover'
        label={intl.formatMessage({id: 'step1.tab5.pccover'})}
        description={
          isShowSubDes &&
					intl.formatMessage({id: 'step1.tab5.pccover_fulltext'})
        }
        icon={<img src={laptopIcon} alt='PC Cover' />}
        isChecked={isPccover}
        setIsChecked={(v) => {
          formikSetField('isPccover', v);
          if (!v && formikValues.travelers) {
            formikValues.travelers.forEach((traveler, index) => {
              clickPcCoverage(traveler, v);
              formikSetField(`traveler-${index}-pcCover`, v);
              traveler.pc = {};
              traveler.needPcCoverage = false;
            });
          }
          if (v && formikValues.travelers.length === 1) {
            clickPcCoverage(formikValues.travelers[0], v);
          }
          setIsPccover(v);
        }}
        classes={classes}
      >
        {isPccover ? (
          <Grid size={12}>
            <FormGroup>
              {formikValues.travelers.map((traveler, i) => (traveler.gender === 1 ? 
                false :
								 (
                  <div>
                    {formikValues.travelers.length > 1 ? (
                      <FormControlLabel
                        key={`traveler-${i}-pcCover`}
                        label={traveler.fullName}
                        aria-label={`${traveler.fullName} ${intl.formatMessage({
                          id: 'step1.tab5.pccover_ariaLabel',
                        })}`}
                        control={
                          <ReusableFormikCheckbox
                            classes={classes}
                            name={`traveler-${i}-pcCover`}
                            isChecked={Boolean(traveler.needPcCoverage)}
                            setIsChecked={(value) => {
                              formikSetField(`traveler-${i}-pcCover`, value);
                              clickPcCoverage(traveler, value);
                            }}
                          />
                        }
                      />
                    ) : null}

                    <Grid className={classes.descriptionAfter2Inputs} size={12}>
                      {renderDescription8After2(traveler, i, formikSetField)}
                    </Grid>
                  </div>
                )),)}
              {formikValues.travelers.length > 1 ? (
                <FormHelperText component='span' error>
                  {formikErrors.pcCoverError}
                </FormHelperText>
              ) : null}
            </FormGroup>
          </Grid>
        ) : null}
      </ReusableFormikCheckbox>
      <ReusableFormikCheckbox
        name='isMobilecover'
        label={intl.formatMessage({id: 'step1.tab5.mobilecover'})}
        description={
          isShowSubDes &&
					intl.formatMessage({id: 'step1.tab5.mobilecover_fulltext'})
        }
        icon={<img src={cellphoneIcon} alt='Mobile Cover' />}
        isChecked={isMobilecover}
        setIsChecked={(v) => {
          formikSetField('isMobilecover', v);
          if (!v && formikValues.travelers) {
            formikValues.travelers.forEach((traveler, index) => {
              clickMobileCoverage(traveler, v);
              formikSetField(`traveler-${index}-mobileCover`, v);
              traveler.mobile = {};
              traveler.needMobileCoverage = false;
            });
          }
          if (v && formikValues.travelers.length === 1) {
            clickMobileCoverage(formikValues.travelers[0], v);
          }
          setIsMobilecover(v);
        }}
        classes={classes}
      >
        {isMobilecover ? (
          <Grid size={12}>
            <FormGroup>
              {formikValues.travelers.map((traveler, i) => (traveler.gender === 1 ? 
                false : (
                  <div>
                    {formikValues.travelers.length > 1 ? (
                      <FormControlLabel
                        key={`traveler-${i}-mobileCover`}
                        label={traveler.fullName}
                        aria-label={`${traveler.fullName} ${intl.formatMessage({
                          id: 'step1.tab5.mobilecover_ariaLabel',
                        })}`}
                        control={
                          <ReusableFormikCheckbox
                            name={`traveler-${i}-mobileCover`}
                            isChecked={Boolean(traveler.needMobileCoverage)}
                            setIsChecked={(value) => {
                              clickMobileCoverage(traveler, value);
                            }}
                            classes={classes}
                          />
                        }
                      />
                    ) : null}
                    <Grid className={classes.descriptionAfter2Inputs} size={12}>
                      {renderDescription9After2(traveler, i, formikSetField)}
                    </Grid>
                  </div>
                )),)}
              {formikValues.travelers.length > 1 ? (
                <FormHelperText component='span' error>
                  {formikErrors.mobileCoverError}
                </FormHelperText>
              ) : null}
            </FormGroup>
          </Grid>
        ) : null}
      </ReusableFormikCheckbox>
      {formikValues.travelers.some((t) => t.age >= 24) && (
        <ReusableFormikCheckbox
          name='isCancellationOfSelfParticipationOnRentedCar'
          label={intl.formatMessage({
            id: 'step1.tab5.cancellationOfSelfParticipationOnRentedCar',
          })}
          description={
            isShowSubDes &&
						intl.formatMessage({
						  id: 'step1.tab5.cancellationOfSelfParticipationOnRentedCar_fulltext',
						})
          }
          icon={<img src={carIcon} alt='Rental Car' />}
          isChecked={isCancellationOfSelfParticipationOnRentedCar}
          setIsChecked={handleIsCancelSelfParticoationOnRentalCar}
          classes={classes}
        >
          {isCancellationOfSelfParticipationOnRentedCar ? (
            <Grid style={{margin: 0}} className={`${classes.descriptionAfter}`} size={12}>
              <FormGroup>
                {formikValues.travelers.length > 1 ?
                  <p className={classes.explainWhatTodoText} htmlFor='isCancellationOfSelfParticipationOnRentedCar'>{intl.formatMessage({id: 'step1.tab5.cancellationOfSelfParticipationOnRentedCar_explain_what_todo'})}</p> :
                  null
                }
                {formikValues.travelers.map((traveler, i) => (traveler.age < 24 ? false :
                  (<div>
                    {formikValues.travelers.length > 1 ? <FormControlLabel
                      key={`traveler-${i}-cancellationOfSelfParticipationOnRentedCar`}
                      label={traveler.fullName}
                      aria-label={`${traveler.fullName} ${intl.formatMessage({id: 'step1.tab5.cancellationOfSelfParticipationOnRentedCar_ariaLabel'})}`}
                      control={<ReusableFormikCheckbox
                        classes={classes}
                        name={`traveler-${i}-cancellationOfSelfParticipationOnRentedCar`}
                        data-testid={`traveler-${i + 1}-cancellationOfSelfParticipationOnRentedCar`}
                        isChecked={Boolean(traveler.cancellationOfSelfParticipationOnRentedCar)}
                        setIsChecked={value => {
                          clickCancellationOfSelfParticipationOnRentedCar(traveler, value);
                        }}
                      />}
                    /> : null }
                  </div>)))}
                {formikValues.travelers.length > 1 ?
                  <FormHelperText
                    style={{margin: '10px'}} component='span' error>
                    {formikErrors.isCancellationOfSelfParticipationOnRentedCarError}
                  </FormHelperText> :
                  null}
              </FormGroup>
            </Grid>
          ) : null }
        </ReusableFormikCheckbox>
      )}
      {handleUpdateRiders ? (
        <Button
          className={classes.submitBtn}
          variant='contained'
          color='primary'
          onClick={async () => {
            const errors = await validateForm();
            if (isPregnancyAndExtremeSportsStatus && !isApprovedPregnancyAndExtremeSports &&
          formikValues?.isPregnancy === 'yes') {
              setIsShowPregnancyAndExtremeSportsPopup(true);
              return;
            }
            if (Object.keys(errors).length === 0) {
              handleUpdateRiders();
              handleGtmEvent();
              setIsRidersChange(false);
            }
          }}
          data-testid='update-riders-btn'
          disabled={!isRidersChange}
        >
          <FormattedMessage id='update-riders-btn' />
        </Button>
      ) : null}
    </FormGroup>
  );
};
RidersList.propTypes = {
  formikValues: PropTypes.shape({
    travelers: PropTypes.arrayOf(
      PropTypes.shape({
        age: PropTypes.number,
        gender: PropTypes.number,
        fullName: PropTypes.string,
        cancellationOfSelfParticipationOnRentedCar: PropTypes.bool,
        needPcCoverage: PropTypes.bool,
        pc: PropTypes.object,
        needMobileCoverage: PropTypes.bool,
        mobile: PropTypes.object,
      }),
    ).isRequired,
    isDetection: PropTypes.bool,
    isLiable: PropTypes.bool,
    isCharger: PropTypes.bool,
    isEsports: PropTypes.bool,
    isWsports: PropTypes.bool,
    isTravelsc: PropTypes.bool,
    isPccover: PropTypes.bool,
    isMobilecover: PropTypes.bool,
    isCancellationOfSelfParticipationOnRentedCar: PropTypes.bool,
    isOwnerHospital2: PropTypes.string,
    policyStartDate: PropTypes.instanceOf(Date),
    policyEndDate: PropTypes.instanceOf(Date),
  }).isRequired,
  formikSetField: PropTypes.func.isRequired,
  formikErrors: PropTypes.object,
  isShowSubDes: PropTypes.bool,
  handleUpdateRiders: PropTypes.func,
  onRidersChange: PropTypes.func,
  showTitleExplainWhatTodoText: PropTypes.bool,
  validateForm: PropTypes.func,
  hideRiders: PropTypes.object,
  setFieldError: PropTypes.func,

};

export default RidersList;